import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import withTheme from '@material-ui/core/styles/withTheme';

class SimpleSnackbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: props.open,
      key: new Date().getTime(),
      message: props.message,
      backgroundColor: props.backgroundColor,
      duration: props.duration,
      vertical: props.vertical,
      horizontal: props.horizontal,
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen(message, backgroundColor = null, duration) {
    this.setState({
      open: true,
      key: new Date().getTime(),
      duration: duration || this.props.duration,
      message,
      backgroundColor,
    });
  }

  handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ open: false });

    const { onClose } = this.props;
    onClose?.(event, reason);
  }

  getBackgroundColor() {
    const { theme } = this.props;
    const { backgroundColor } = this.state;
    switch (backgroundColor) {
      case 'info':
        return theme.palette.info.dark;
      case 'success':
        return theme.palette.success.dark;
      case 'warning':
        return theme.palette.warning.dark;
      case 'error':
        return theme.palette.error.dark;
      default:
        return backgroundColor;
    }
  }

  render() {
    const { open, key, message, vertical, horizontal, duration } = this.state;
    const { actionButton } = this.props;
    const backgroundColor = this.getBackgroundColor();

    return (
      <Snackbar
        key={key}
        anchorOrigin={{
          vertical: vertical,
          horizontal: horizontal,
        }}
        open={open}
        onClose={this.handleClose}
        autoHideDuration={duration}
        message={message}
        action={
          <React.Fragment>
            {actionButton}
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={this.handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
        ContentProps={{
          style: {
            display: 'flex',
            flexWrap: 'nowrap',
            alignItems: 'center',
            ...(!!backgroundColor && { backgroundColor }),
          },
        }}
      />
    );
  }
}

SimpleSnackbar.defaultProps = {
  open: false,
  duration: 3000,
  vertical: 'bottom',
  horizontal: 'center',
};

SimpleSnackbar.propTypes = {
  open: PropTypes.bool,
  message: PropTypes.node,
  backgroundColor: PropTypes.string,
  duration: PropTypes.number,
  onClose: PropTypes.func,
  actionButton: PropTypes.node,
  vertical: PropTypes.oneOf(['top', 'bottom']),
  horizontal: PropTypes.oneOf(['left', 'center', 'right']),
};

export default withTheme(SimpleSnackbar);
